import { createStore } from 'vuex'

import modules from './modules'

const store = createStore({
  state : {
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    dasboardStats: JSON.parse(localStorage.getItem('dasboardStats')),
    selectedTaxCategories: JSON.parse(localStorage.getItem('selectedTaxCategories')),
    selectedEtablissement: JSON.parse(localStorage.getItem('selectedEtablissement')),
    selectedRamification: JSON.parse(localStorage.getItem('selectedRamification')),
    selectedCentre: JSON.parse(localStorage.getItem('selectedCentre')),
    selectedCentreDeclaration: JSON.parse(localStorage.getItem('selectedCentreDeclaration')),
    selectedAnnee: localStorage.getItem('selectedAnnee'),
    userRamifications: JSON.parse(localStorage.getItem('userRamifications')),
    userEntites: JSON.parse(localStorage.getItem('userEntites')),
    daterange: localStorage.getItem('daterange'),
    jwt_token: localStorage.getItem('jwt_token'),
    refresh_token: localStorage.getItem('refresh_token'),

  },
  modules,

  mutations : {
    SET_JWT_TOKEN(state, newValue) {
      state.jwt_token = newValue
      saveState('setJwtToken', newValue)
    },
    SET_REFRESH_TOKEN(state, newValue) {
      state.refresh_token = newValue
      saveState('setRefreshToken', newValue)
    },
    SET_SELECTED_TAX_CATEGORIE(state, newValue) {
      state.refresh_token = newValue
      saveState('setSelectedTaxCategories', newValue)
    },
    SET_SELECTED_RAMIFICATION(state, newValue) {
      state.selectedRamification = newValue
      saveState('setSelectedRamification', newValue)
    },
    SET_SELECTED_CENTRE(state, newValue) {
      state.selectedCentre = newValue
      saveState('setSelectedCentre', newValue)
    },
    SET_SELECTED_CENTRE_DECLARATION(state, newValue) {
      state.selectedCentreDeclaration = newValue
      saveState('setSelectedCentreDeclaration', newValue)
    },
    SET_CURRENT_USER(state, newValue) {
      state.currentUser = newValue
      saveState('currentUser', newValue)
    },
    SET_DATERANGE(state, newValue) {
      state.daterange = newValue
      saveState('setDaterange', newValue)
    },
    SET_USER_ENTITES(state, newValue) {
      state.userEntites = newValue
      saveState('setUserEntites', newValue)
    },
    SET_USER_RAMIFICATIONS(state, newValue) {
      state.userRamifications = newValue
      saveState('setUserRamifications', newValue)
    },
    SET_DASHBOARD_STATS(state, newValue) {
      state.dasboardStats = newValue
      saveState('dasboardStats', newValue)
    },
    SET_SELECTED_ETABLISSEMENT(state, newValue) {
      state.selectedEtablissement = newValue
      saveState('selectedEtablissement', newValue)
    },
    SET_SELECTED_ANNEE(state, newValue) {
      state.selectedAnnee = newValue
      saveState('setAnnee', newValue)

    },

  },
  getters : {
    // Whether the user is currently logged in.
    loggedIn(state) {
      return !!state.currentUser
    },

  },
  actions : {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    setJwtToken({ commit }, token) {
      commit('SET_JWT_TOKEN', token)
    },
    setRefreshToken({ commit }, token) {
      commit('SET_REFRESH_TOKEN', token)
    },
    setSelectedTaxCategories({ commit }, token) {
      commit('SET_SELECTED_TAX_CATEGORIE', token)
    },
    setUserEntites({ commit }, entites) {
      commit('SET_USER_ENTITES', entites)
    },
    setSelectedRamification({ commit }, ramification) {
      commit('SET_SELECTED_RAMIFICATION', ramification)
    },
    setSelectedCentre({ commit }, centre) {
      commit('SET_SELECTED_CENTRE', centre)
    },
    setSelectedCentreDeclaration({ commit }, centre) {
      commit('SET_SELECTED_CENTRE_DECLARATION', centre)
    },
    setDaterange({ commit }, daterange) {
      commit('SET_DATERANGE', daterange)
    },
    setAnnee({ commit }, annee) {
      commit('SET_SELECTED_ANNEE', annee)
    },
    setUserRamifications({ commit }, ramifications) {
      commit('SET_USER_RAMIFICATIONS', ramifications)
    },

    // Logs in the current user.
    logIn({ commit }, user= {}) {
      commit('SET_CURRENT_USER', user)
    },
    dasboardStats({ commit }, stats= {}) {

      commit('SET_DASHBOARD_STATS', stats)
    },
    setSelectedEtablissement({ commit }, etablissement) {

      commit('SET_SELECTED_ETABLISSEMENT', etablissement)
    },
  },
  strict: process.env.NODE_ENV !== 'production',
})

export default store

function saveState(key, state) {
  window.sessionStorage.setItem(key, JSON.stringify(state))
}